exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".listContainer___1tp9A {\n  margin-top: 1rem;\n  overflow: auto;\n  position: relative;\n  padding: 1rem;\n  min-height: 0;\n  height: auto;\n}\n\n.listContainer___1tp9A > div {\n  width: 95%;\n  position: absolute !important;\n}\n", "", {"version":3,"sources":["/./studio/studio/ReportEditor.scss"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,aAAa;CACd;;AAED;EAEE,WAAW;EAEX,8BAA8B;CAC/B","file":"ReportEditor.scss","sourcesContent":[".listContainer {\r\n  margin-top: 1rem;\r\n  overflow: auto;\r\n  position: relative;\r\n  padding: 1rem;\r\n  min-height: 0;\r\n  height: auto;\r\n}\r\n\r\n.listContainer > div {\r\n  // it somehow shows the horizontal scrollbar even when no needeit, this workaround to hide it\r\n  width: 95%;\r\n  // the tabs height based on flex box is otherwise wrongly calculated\r\n  position: absolute !important;\r\n}\r\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"listContainer": "listContainer___1tp9A"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=2&sourceMap&localIdentName=[local]___[hash:base64:5]!./~/sass-loader?outputStyle=expanded&sourceMap!./studio/ReportEditor.scss
 ** module id = 4
 ** module chunks = 0
 **/